module.exports = __webpack_public_path__ + "static/media/add-user.cfe3ded9.png";